import { useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useGetImgixImageUrl } from '../../../../../hooks';
import { Anchor } from '../../../../shared/Anchor';
import {
  EXPERIENCE_TYPE_LABELS,
  RibbonTypes,
  imagesMap,
  ribbonMap,
} from './constants';
import { isNoRibbonStripeExperience } from './helpers';
import s from './BuyExperiences.module.scss';

export const ExperienceCard = ({ experience, ribbonType }) => {
  const showNoRibbonStripeExperience = isNoRibbonStripeExperience(
    ribbonType,
    experience?.type,
  );

  const imagePath = useMemo(() => {
    if (!experience?.type || !ribbonType || showNoRibbonStripeExperience) {
      return '';
    }

    return imagesMap[ribbonType]?.[experience.type] ?? '';
  }, [experience?.type, ribbonType, showNoRibbonStripeExperience]);

  const path = useGetImgixImageUrl(imagePath);

  const image = useMemo(() => {
    if (experience.image || !imagePath) {
      return experience.image;
    }
    return path;
  }, [experience.image, path, imagePath]);

  const anchorClassName = cn({
    'embed-responsive embed-responsive-16by10': true,
    [s.image]: true,
    [s.stripeImage]: !experience.image && !showNoRibbonStripeExperience,
    [s.noRibbonImage]: showNoRibbonStripeExperience,
  });

  const labelClassName = cn(s.noRibbonLabel, {
    [s.noRibbonLabelBlack]: ribbonType === RibbonTypes.NO_RIBBON_BLACK_TEXT,
  });

  return (
    <div className="col-xs-12 col-sm-4">
      <div className={s.card}>
        <Anchor to={experience.link} className={anchorClassName}>
          {showNoRibbonStripeExperience ? (
            <span className={labelClassName}>
              {EXPERIENCE_TYPE_LABELS[experience.type]}
            </span>
          ) : (
            <>
              <img
                src={ribbonMap[ribbonType] ?? ribbonMap.BLACK_RIBBON_WHITE_TEXT}
                alt=""
                className="embed-responsive-item"
              />
              <img src={image} alt="" className="embed-responsive-item" />
            </>
          )}
        </Anchor>
        <Anchor to={experience.link} className={s.button}>
          Buy Now
        </Anchor>
      </div>
    </div>
  );
};

ExperienceCard.propTypes = {
  experience: PropTypes.shape({
    type: PropTypes.string,
    link: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  ribbonType: PropTypes.string,
};
